<template>
  <div>
    <div class="select_tab">
      <el-radio-group v-model="selectBtn">
        <el-radio-button label="1">输入邮箱</el-radio-button>
        <el-radio-button label="2">选择用户</el-radio-button>
      </el-radio-group>
    </div>
    <template v-if="selectBtn == 1">
      <div class="input_email_box">
        <div class="input_email">
          <div class="input_email_title">邮箱：</div>
          <el-input v-model="address" placeholder="请输入收件人邮箱"></el-input>
        </div>
      </div>
    </template>
    <template v-if="selectBtn == 2">
      <div class="select_member">
        <div class="select_member_title">邮箱：</div>
        <el-select v-model="userIds" placeholder="请选择" filterable>
          <el-option
            v-for="item in memberList"
            :key="item.userId"
            :label="item.nickName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </div>
    </template>
    <div class="footer_btn">
      <el-button type="primary" @click="handleSubmit()" style="width: 100px"
        >提交</el-button
      >
      <el-button
        type="error"
        @click="handleClose()"
        style="width: 100px; margin-left: 10px"
        >取消</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    begin: "",
    end: "",
    type: "",
  },
  data() {
    return {
      address: "",
      selectBtn: 1,
      table: {
        mname: "youxiang",
        key: "id",
        url: {},
      },
      formDynamic: {},
      memberList: [],
      userIds: "",
    };
  },
  async created() {
    this.getMember();
  },
  methods: {
    async getMember() {
      let q = {};
      let res = await $utils.api.load("/admin/system/user/list", q, "get");
      if (res.code == 200) {
        this.memberList = res.rows;
      }
    },
    toggleBlock() {
      this.block = true;
    },
    async handleSubmit() {
      let q = {
        begin: new Date(this.begin),
        end: new Date(this.end),
        userIds: "",
        address: "",
        type: Number(this.type),
      };
      if (this.selectBtn == 1) {
        q.address = this.address;
        if (!q.address) {
          $utils.toast.error("邮箱地址为空，请重新输入！");
          return;
        }
      }
      if (this.selectBtn == 2) {
        if (!this.userIds) {
          $utils.toast.error("请选择用户！");
          return;
        }
        q.userIds = this.userIds + "";
        let addressUser = this.memberList.find((item) => item.userId === this.userIds)
          ?.email;
        if (!addressUser) {
          $utils.toast.error("当前选择的用户未配置邮箱，请重新选择！");
          return;
        }
      }
      this.loading = true;
      try {
        let res = await $utils.api.load(
          "/admin/system/check/checkDeskCountEmail",
          q,
          "post"
        );
        if (res.code === 200) {
          this.$Modal.remove();
          $utils.toast.success(res.msg);
        } else {
          $utils.toast.error(res.msg);
        }
      } catch (error) {
        $utils.toast.error("请求失败，请稍后重试！");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleRemove(index) {
      this.formDynamic.items[index].status = 0;
    },
    handleClose() {
      this.$Modal.remove();
    },
  },
};
</script>

<style scoped lang="less">
.select_tab {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.input_email {
  display: flex;
  align-items: center;

  .input_email_title {
    width: 100px;
  }
}

.select_member {
  display: flex;
  width: 100%;
  align-items: center;

  .select_member_title {
    width: 100px;
  }
}

.footer_btn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title {
  font-size: 14px;
  color: #515a6e;
}
</style>
